import * as React from 'react';
import {Box, Card, CardContent, Typography} from "@mui/material";
import makeAverage from "../../../../utils/makeAverage";

interface IBusinessProfileProps {
    final: any[],
}

const BusinessModelImprovement = ({final}: IBusinessProfileProps) => {
    return (
        <Card className="chart-container">
            <CardContent>
                <div className="space-y-4">
                    <Typography>
                        Level of improvement of the business model
                    </Typography>
                    <Box
                        sx={{
                            p: 1,
                            border: '1px solid grey',
                            textAlign: 'right',
                            fontSize: '1rem',
                            backgroundColor: 'rgb(243, 244, 246)',
                        }}
                    >
                        <div>
                            {
                                "Ranking: very low - 1 >  6- very high"
                            }
                        </div>
                        <div className="bold">
                            Average: { makeAverage(final.map((submission: any) => Number(submission.biz_mod_improved_t1)), 2) }
                        </div>
                    </Box>

                </div>
            </CardContent>
        </Card>
    );
};

export default BusinessModelImprovement;
